import React from 'react'
import { IconButton } from '../Button'

export type BreadCrumbItemProps = Readonly<{
	label: string
	value: string
	onClick?: () => void
	icon?: React.ReactNode
}>

export default function BreadcrumbItem({
	label,
	onClick,
	icon,
	value,
}: BreadCrumbItemProps) {
	return (
		<IconButton
			onClick={onClick}
			aria-label={value}
			style={{ borderRadius: 8 }}
			sx={{ pointerEvents: onClick ? 'auto' : 'none' }}
		>
			<div className="flex flex-row items-center gap-1">
				{icon}
				{!!label && <div className="text-sm">{label}</div>}
			</div>
		</IconButton>
	)
}
